/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum StickyCategory {
  Finance = "finance",
  Operations = "operations",
  Sales = "sales",
  Engineering = "engineering",
}

export function instanceOfStickyCategory(value: any): boolean {
  for (const key in StickyCategory) {
    if (Object.prototype.hasOwnProperty.call(StickyCategory, key)) {
      if (StickyCategory[key as keyof typeof StickyCategory] === value) {
        return true;
      }
    }
  }
  return false;
}

export function StickyCategoryFromJSON(json: any): StickyCategory {
  return StickyCategoryFromJSONTyped(json, false);
}

export function StickyCategoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StickyCategory {
  return json as StickyCategory;
}

export function StickyCategoryToJSON(value?: StickyCategory | null): any {
  return value as any;
}

export function StickyCategoryToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): StickyCategory {
  return value as StickyCategory;
}
